export default __webpack_public_path__ + "locales/sq-AL/ChangePasswordDialog.json?hash=e883d11060febc4032115b8548c86ec5";